import { useState } from 'react';
import classnames from 'classnames';
import _isEmpty from 'lodash/isEmpty';

import Autosuggest from 'components/autosuggestInput';
import ZpButton from 'components/zpButton';
import { FILTER_PARAMS, filterSearchKey } from 'components/zpFilter/filterUtils';
import {
  buildCmpSubpagesUrls,
  buildUrlUsingTitleAndLocation,
  computeString,
  isValidLocationString,
  splitLocation,
} from 'utils';
import { CMP_SUBPAGES, CPP_SUBPAGES } from 'utils/constant';

import classes from './index.module.css';

const defaultProps = {
  jobTitle: '',
  userLocation: '',
  className: '',
  redirectPage: null,
  TitleTagName: 'h3',
  src: '',
  redirectUrl: '',
};

export const FindJobs = ({
  jobTitle,
  userLocation,
  className,
  redirectPage,
  TitleTagName,
  src,
  redirectUrl,
}) => {
  const [title, setTitle] = useState(jobTitle);
  const [location, setLocation] = useState(userLocation);

  const onTitleChange = (e) => {
    if (!_isEmpty(e?.valueObj)) setTitle(e.displayValue);
    else setTitle('');
  };

  const onLocationChange = (e) => {
    if (!_isEmpty(e?.valueObj)) setLocation(e.displayValue);
    else setLocation('');
  };

  const onClick = () => {
    let url;

    if (title && location && location.length) {
      url = buildUrlUsingTitleAndLocation(title, location);
    } else if (title) {
      url = buildCmpSubpagesUrls(title, null, CMP_SUBPAGES.JOBS);
    } else if (location && location.length) {
      url = buildUrlUsingTitleAndLocation(null, location);
    }

    if (title && redirectPage === CMP_SUBPAGES.JOBS && !redirectUrl) {
      url = buildCmpSubpagesUrls(title, null, CMP_SUBPAGES.JOBS);

      if (isValidLocationString(location) && location !== '') {
        const { city, stateAbbr } = splitLocation(location);
        localStorage.setItem(
          filterSearchKey,
          JSON.stringify({
            [FILTER_PARAMS.LOCATION]: [
              {
                city: city,
                state: stateAbbr,
              },
            ],
          })
        );
      }
    } else if (redirectUrl && redirectPage === CPP_SUBPAGES.JOBS) {
      url = `${redirectUrl}${redirectPage}/#`;
      if (title) {
        url += `jobTitle=${title}`;
      }
      if (location) {
        url += `&location=${location}`;
      }
    }

    if (title && src) {
      url += src;
    }

    if (url) window.open(url, '_blank');
  };

  return (
    <div className={classnames(classes.container, className)}>
      <TitleTagName className={classnames('zp-title-h3', classes.title)}>
        {computeString('Search For', jobTitle, 'Jobs')}
      </TitleTagName>
      <Autosuggest
        category="jobTitle"
        prefillValue={jobTitle}
        inputProps={{
          className: classnames('zp-input', classes.input),
          placeholder: 'Job Title',
        }}
        onChange={onTitleChange}
      />
      <Autosuggest
        category="location"
        prefillValue={location}
        inputProps={{
          className: classnames('zp-input', classes.input),
          placeholder: 'Location',
        }}
        onChange={onLocationChange}
      />
      <ZpButton theme="super-primary" size="big" isFullWidth onClick={onClick}>
        Find Jobs
      </ZpButton>
    </div>
  );
};

FindJobs.defaultProps = defaultProps;
